import { render, staticRenderFns } from "./CliPL_List.vue?vue&type=template&id=50f0d4c9"
import script from "./CliPL_List.vue?vue&type=script&lang=js"
export * from "./CliPL_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports